"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9078],{

/***/ 79992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ImagePosition; },
/* harmony export */   "k": function() { return /* binding */ ListCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74183);




var ImagePosition;
(function(ImagePosition) {
    ImagePosition["Left"] = "left";
    ImagePosition["Right"] = "right";
})(ImagePosition || (ImagePosition = {}));
var ListCta = function(param) {
    var imgSrc = param.imgSrc, imgWidth = param.imgWidth, imgHeight = param.imgHeight, _items = param.items, items = _items === void 0 ? [] : _items, className = param.className, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? ImagePosition.Left : _imagePosition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("bg-footer rounded text-footer-foreground grid lg:grid-flow-col p-6 gap-4 relative shadow-lg [&>*]:border-b-[1px] [&>*]:lg:border-b-0 [&>*:not(:last-child)]:lg:border-r-[1px] [&>*:not(:last-child)]:border-teal-300", className),
        children: [
            imagePosition === ImagePosition.Left && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("hidden lg:flex items-center lg:col-span-3 px-4"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative -mt-16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: imgSrc,
                        width: imgWidth,
                        height: imgHeight
                    })
                })
            }),
            items.map(function(it) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 col-span-12 lg:col-span-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "font-bold text-xl mb-2",
                            children: it.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "list-disc marker:text-listMarker",
                            children: it.list.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "mb-2 ml-6 font-semibold",
                                    children: item.text
                                }, item.text);
                            })
                        })
                    ]
                }, it.title);
            }),
            imagePosition === ImagePosition.Right && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__.cn)("hidden lg:flex items-center lg:col-span-3 justify-self-end"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative -mt-16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: imgSrc,
                        width: imgWidth,
                        height: imgHeight
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 29016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58020);



var PageHeadingSection = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex-col justify-start items-start gap-4 inline-flex",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-sky-950 text-[32px] font-bold leading-10",
                children: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "self-stretch text-sky-950 text-[14px] font-normal leading-normal",
                children: props.subtitle
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center align-center gap-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                variant: "h1",
                className: "text-center",
                asChild: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .Z, {
                variant: "h4",
                className: "text-center"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeadingSection);


/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 65558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8222);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19475);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46035);
/* harmony import */ var _features_usersSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97219);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58020);
/* harmony import */ var _components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59743);
/* harmony import */ var _components_ui_badge__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95034);
/* harmony import */ var _components_ui_separator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3127);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74183);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94916);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5097);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(49525);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72175);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86871);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82701);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16685);
/* harmony import */ var _features_timezoneSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70118);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1438);
/* harmony import */ var _util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80995);



















var CaseCard = function(param) {
    var caseId = param.caseId;
    var ref, ref1;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_11__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var userId = currentCase === null || currentCase === void 0 ? void 0 : currentCase.user;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return userId ? (0,_features_usersSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectUserById */ .Ls)(state, userId) : null;
    });
    var timezone = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_features_timezoneSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectTimezone */ .pE);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoginOverlayVisible = ref2[0], setIsLoginOverlayVisible = ref2[1];
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    var isOpenCase = !auth.isAuthenticated && (currentCase === null || currentCase === void 0 ? void 0 : currentCase.public) || auth.isAuthenticated;
    var onFocus = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__/* .useStableCallback */ .R)(function() {
        if (!isOpenCase) {
            setIsLoginOverlayVisible(true);
        }
    });
    var onBlur = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_16__/* .useStableCallback */ .R)(function() {
        setIsLoginOverlayVisible(false);
    });
    if (!currentCase) {
        return null;
    }
    //convert expertise to set to remove duplicates
    var expertises = new Set((ref = currentCase.expertises) === null || ref === void 0 ? void 0 : ref.map(function(expertise) {
        return expertise.title;
    }));
    var isPublic = currentCase.public;
    var isUpcoming = currentCase.scheduled_to > Date.now() / 1000;
    var description = currentCase.excerpt;
    var title = currentCase.title;
    var state = currentCase === null || currentCase === void 0 ? void 0 : currentCase.state;
    var isPlaceholder = state === _constants__WEBPACK_IMPORTED_MODULE_15__/* .CaseStatuses.TENTATIVE */ .HM.TENTATIVE;
    var isClosed = state === _constants__WEBPACK_IMPORTED_MODULE_15__/* .CaseStatuses.CLOSED */ .HM.CLOSED;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCard */ .hZ, {
        className: "flex flex-col hover:bg-teal-50",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardHeader */ .B1, {
                className: "px-6 pt-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between gap-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-wrap gap-1",
                            children: isPublic ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_badge__WEBPACK_IMPORTED_MODULE_9__/* .Badge */ .C, {
                                variant: "secondary",
                                className: "bg-teal-200",
                                children: "Free"
                            }) : null
                        })
                    }),
                    isPlaceholder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                        className: "decoration-0 font-semibold text-lg line-clamp-2",
                        variant: "large",
                        children: title
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/case/".concat(caseId),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                            className: "decoration-0 font-semibold text-lg line-clamp-2",
                            variant: "large",
                            asChild: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: title
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardContent */ .w9, {
                className: "px-6 gap-4 h-full flex flex-col justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardDescription */ .ht, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("animate flex items-center absolute inset-0 pointer-events-none bg-teal-50 backdrop-blur-2xl", {
                                            "opacity-0": !isLoginOverlayVisible
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                "Become a Casehub member to see more. ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "Free trial for 14 days"
                                                }),
                                                ", cancel any time."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                        variant: "default",
                                        className: "line-clamp-6",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-wrap gap-1 text-muted-foreground text-xs",
                                children: (ref1 = Array.from(expertises)) === null || ref1 === void 0 ? void 0 : ref1.map(function(exp) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            "#",
                                            exp
                                        ]
                                    }, exp);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardIcons */ .qB, {
                                children: [
                                    (!isUpcoming || currentCase.comment_count > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                        variant: "badge",
                                        size: "subtle",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            currentCase.comment_count
                                        ]
                                    }),
                                    (isUpcoming || currentCase.register_count > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                            variant: "badge",
                                            size: "subtle",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    className: "w-4 h-4"
                                                }),
                                                currentCase.register_count,
                                                "/",
                                                currentCase.register_max
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isUpcoming && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            (0,_util_format__WEBPACK_IMPORTED_MODULE_13__/* .formatDate */ .p6)({
                                                ts: currentCase.scheduled_to,
                                                format: "medium",
                                                tz: timezone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex gap-x-2 text-xs text-muted-foreground items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                className: "w-4 h-4"
                                            }),
                                            " ",
                                            currentCase.duration || _constants__WEBPACK_IMPORTED_MODULE_15__/* .DEFAULT_SESSION_DURATION_IN_MINUTES */ .pg,
                                            " min"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_separator__WEBPACK_IMPORTED_MODULE_10__/* .Separator */ .Z, {
                                className: "mb-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardActions */ .Je, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onMouseEnter: onFocus,
                            onMouseLeave: onBlur,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, {
                                asChild: true,
                                variant: "outline",
                                size: "lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: isLoginOverlayVisible ? "/pricing" : "/case/".concat(currentCase.id),
                                    children: [
                                        isLoginOverlayVisible ? "Become a member" : "Enter case",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                            className: "w-4 h-4"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_case_card__WEBPACK_IMPORTED_MODULE_8__/* .CaseCardFooter */ .At, {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("flex px-6 py-2 items-center space-x-4", {
                    "bg-gray-200": isClosed,
                    "bg-cardFooter": !isClosed
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__/* .UserAvatar */ .Y, {
                        userId: userId,
                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_17__.cn)("my-4")
                    }),
                    !!user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm font-medium leading-none",
                                children: (0,_util_format__WEBPACK_IMPORTED_MODULE_13__/* .formatName */ .KY)(user)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: user.position
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaseCard);


/***/ }),

/***/ 10527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ usePagination; }
/* harmony export */ });
/* unused harmony export useKeyWindowId */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46035);
/* harmony import */ var _features_keyWindowsSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53874);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32132);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19475);





var useKeyWindowId = function(param) {
    var category = param.category, statuses = param.statuses, orderBy = param.orderBy, sortOrder = param.sortOrder;
    var auth = (0,_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    var userId = auth.user ? auth.user.id : undefined;
    var statusesKey = statuses.join(",");
    return [
        statusesKey,
        category,
        userId,
        orderBy,
        sortOrder
    ].filter(Boolean).join("_");
};
var usePagination = function(param) {
    var pageSize = param.pageSize, orderBy = param.orderBy, initialPageSize = param.initialPageSize, statuses = param.statuses, category = param.category, sortOrder = param.sortOrder;
    var auth = (0,_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    var userId = auth.user ? auth.user.id : undefined;
    var statusesKey = statuses.join(",");
    var keyWindowId = useKeyWindowId({
        category: category,
        statuses: statuses,
        orderBy: orderBy,
        sortOrder: sortOrder
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var keyWindow = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return (0,_features_keyWindowsSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectKeyWindowById */ .Af)(state, keyWindowId);
    });
    var offset = keyWindow ? keyWindow.offset : 0;
    var currentPageSize = offset === 0 ? initialPageSize : pageSize;
    var itemsLeft = Math.max(keyWindow && keyWindow.found ? keyWindow.found - (offset + currentPageSize) : 0, 0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_3__/* .fetchCasesByStatus */ .Tr)({
            category: category,
            status: statusesKey,
            limit: offset === 0 ? initialPageSize : pageSize,
            offset: offset,
            userId: userId,
            orderBy: orderBy,
            sortOrder: sortOrder
        }));
    }, [
        dispatch,
        statusesKey,
        pageSize,
        offset,
        category,
        initialPageSize,
        userId,
        orderBy,
        sortOrder
    ]);
    return {
        fetchNextPage: function() {
            dispatch((0,_features_keyWindowsSlice__WEBPACK_IMPORTED_MODULE_2__/* .setKeyWindowOffset */ .$n)({
                id: keyWindowId,
                offset: offset + currentPageSize
            }));
        },
        itemsLeft: itemsLeft,
        hasNextPage: itemsLeft > 0
    };
};


/***/ })

}]);